// Image imports
import yazanPhoto from '../../../images/yazan_photo.jpg';

export const yazanAbuJamaaMemorial = {
  id: 8,
  name: 'Yazan Abu Jamaa',
  category: 'young-lives',
  images: {
    portrait: yazanPhoto
  },
  info: `

"Where is the Iron Dome? Why didn't it work? Why didn't it shoot down the rocket?" - Zakaria Abu Jamaa, Yazan's father

![Yazan Abu Jamaa](${yazanPhoto})
*Yazan Abu Jamaa, a 5-year-old boy whose life was tragically cut short*

## A Young Life Lost

Yazan Zakaria Abu Jamaa, a 5-year-old boy from the southern Bedouin town of Ar'ara, was tragically killed on October 7, 2023, when a rocket fired from Gaza struck his home.

## The Tragic Day

On that fateful Saturday morning, Yazan was standing at the door of his house near a car when the rocket exploded. The blast was so powerful that it blew the car out of place and set it on fire along with several other vehicles. Tragically, Yazan was killed instantly, his small body torn apart by the explosion.

## A Family's Grief

Yazan is survived by his parents and three sisters. His father, Zakaria, a driver, was in Eilat when he learned of his son's death. He rushed back home amidst the ongoing conflict to find his beloved son in the hospital.

Zakaria's grief is palpable in his words:

> "I'm broken, I can't talk about this now, I just can't… I leave my house just to go to the cemetery. The rest of the time I sit on my balcony and I smoke and drink coffee."

Months after the tragedy, the pain remains raw:

> "Every night I wake up and I see that the pain in my heart just grows and grows."

## A Preventable Tragedy?

The Abu Jamaa family, like many in their community, believes that Yazan's death could have been prevented. Their town lacks sirens and rocket shelters, leaving residents vulnerable to attacks. Zakaria questions the effectiveness of Israel's defense systems:

> "Where is the Iron Dome? Why didn't it work? Why didn't it shoot down the rocket?"

## A Community at Risk

Yazan's death highlights the vulnerability of Bedouin communities in southern Israel. Many of these towns and villages lack basic protective infrastructure such as rocket alarm systems and shelters. This disparity in protection puts these communities at greater risk during conflicts.

## Remembering Yazan

Yazan was Zakaria's only son, a cherished member of the family alongside his three sisters. His death has left a void that can never be filled. As we remember Yazan, we are reminded of the innocent lives caught in the crossfire of conflict and the urgent need for equal protection for all communities.

May Yazan's memory be a blessing and a call for change.

[Read more about Yazan Abu Jamaa](https://october7memorial.com/memoriam/yazan-abu-jamaa)

[Learn about the impact on Israel's Bedouin community](https://www.ynetnews.com/magazine/article/hkj4bwqwt)

`
};